import FormInputTypes from '../../../components/atoms/formEnums/formInputTypes';
// import tableVodCatalog from './tableVodTemplateCatalog';

export default {
  title: 'Cameras Management',
  visibleWhen: {"field":"deploymentType","value":'ott'},
  attributeName: 'liveCamerasConfiguration',
  fields: [
    {
      attributeName: 'outFPS',
      type: FormInputTypes.SELECT,
      default:'60',
      options: [
        { name: '30', value: 30 },
        { name: '60', value: 60 },
      ],
      label: 'Output FPS',
      helpText: 'Output FPS.',
      errorText: '',
      visibleWhen:{"field":"deploymentType","value":'ott'},
    },
    {
      attributeName: 'segmentLength',
      type: FormInputTypes.SELECT,
      default:'60',
      options: [
        { name: '600ms', value: 0.6 },
        { name: '4.8s', value: 4.8 },
      ],
      label: 'Segment Length',
      helpText: 'SegmentLength.',
      errorText: '',
      enabledWhen:{"field":"allowGOP","values":[true]},
      visibleWhen:{"field":"deploymentType","value":'ott'},
    },
    {
      attributeName: 'videoCodec',
      type: FormInputTypes.SELECT,
      label: 'Video codec',
      default:'hevc_nvenc',
      options: [
        { name: 'hevc_nvenc', value: 'hevc_nvenc' },
        { name: 'h264_nvenc', value: 'h264_nvenc' },
        { name: 'av1_nvenc', value: 'av1_nvenc' },
      ],
      helpText: 'Video codec .',
      errorText: '',
      visibleWhen:[{"field":"deploymentGPU","value":true},{"field":"deploymentType","value":'ott'}],
    },
    {
      attributeName: 'videoCodec',
      type: FormInputTypes.SELECT,
      label: 'Video codec',
      default:'hevc_nvenc',
      options: [
        { name: 'libx264', value: 'libx264' },
      ],
      helpText: 'Video codec .',
      errorText: '',
      visibleWhen:[{"field":"deploymentGPU","notValue":true},{"field":"deploymentType","value":'ott'}]
    },
    {
      attributeName:"sep3",
      type:FormInputTypes.SEPARATOR
    },

    {
      attributeName: 'mainCamera',
      helpText: 'Main Camera to be selected',
      type: FormInputTypes.SELECT,
      label: 'Main Camera',
      placeholder: 'Add the main camera to be sent to live backend',
      multiple: false,
      url: 'liveGetStreamVideoPublish',
      emptyValue:true,
      fieldValue:'videoPublishID',
      fieldName:'videoPublishID',
      pageId:true,
      asyncSelect: true,
      options:[],
    },
  ],
  
};
